import { tv } from 'tailwind-variants'

export const card = tv({
  slots: {
    container:
      'relative flex flex-col overflow-hidden rounded-lg border border-solid bg-ui-light p-4',
    bgImage: 'absolute bottom-0 left-0 right-0 top-0',
  },
  variants: {
    borderless: {
      true: { container: 'border-0' },
    },
  },
})
